import { CompletionStep } from './steps/completion-step';
import { FormBuilderStep } from './steps/form-builder-step';
import { SetupEmailsStep } from './steps/setup-emails-step';
import type { PreboardingFormStepProps } from './steps/setup-emails-step';
import { WelcomeStep } from './steps/welcome-step';

export type WizardStepId = 'setup' | 'welcome' | 'builder' | 'completion';

export interface WizardStep {
  id: WizardStepId;
  label: string;
  /** Short caption rendered under the step title in the wizard header. */
  caption: string;
  Component: (props: PreboardingFormStepProps) => React.ReactElement;
}

// The fixed 4-step sequence of the Pre-boarding Form builder (HW-554).
export const WIZARD_STEPS: WizardStep[] = [
  { id: 'setup', label: 'Setup & Emails', caption: 'Form details and automated emails', Component: SetupEmailsStep },
  { id: 'welcome', label: 'Welcome', caption: 'External welcome screen', Component: WelcomeStep },
  { id: 'builder', label: 'Form Builder', caption: 'Sections, fields, and documents', Component: FormBuilderStep },
  { id: 'completion', label: 'Completion', caption: 'Thank-you screen', Component: CompletionStep },
];
